import NumberPlate from "./NumberPlate";

export default NumberPlate